export default __webpack_public_path__ + "536e75acf0d81fd2ad7f538e75f2acc2.png";